import * as service from './services'
import to from 'await-to-js'

export const state = {
  listAgenda: []
}

export const getters = {
  listAgenda: state => state.listAgenda
}

export const mutations = {
  setListAgenda (state, payload) {
    state.listAgenda = payload
  }
}

export const actions = {
  async findAgendaProfissional ({commit, dispatch}, profissional) {
    dispatch('setLoading', true)
    const [error, response = { data: [] }] = await to(service.getAgendaPorProfissional(profissional))
    dispatch('setLoading', false)
    if (error) {
      throw error
    }
    commit('setListAgenda', response.data)
    return response.data
  },

  async confirmarAgendamento ({commit, dispatch}, agendamento) {
    dispatch('setLoading', true)
    const [error, response = { data: [] }] = await to(service.confirmarAgendamento(agendamento))
    dispatch('setLoading', false)
    if (error) {
      throw error
    }
    return response.data
  },

  async cancelarAgendamento ({commit, dispatch}, agendamento) {
    dispatch('setLoading', true)
    const [error, response = { data: [] }] = await to(service.cancelarAgendamento(agendamento))
    dispatch('setLoading', false)
    if (error) {
      throw error
    }
    return response.data
  },

  async findAgendaProfissionalCompleta ({commit, dispatch}, profissional) {
    dispatch('setLoading', true)
    const [error, response = { data: [] }] = await to(service.getAgendaPorProfissionalCompleta(profissional))
    dispatch('setLoading', false)
    if (error) {
      throw error
    }
    commit('setListAgenda', response.data)
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/gerenciarAgendamento/index.js